import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { APPCONFIG } from "../config";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AcordoService extends BaseService {

    dadosAcordos: Observable<any>;

    constructor(private http: Http) {
        super();
        this._api = '/api/acordos/';        
    }
        
    postAcordo(dados : any){        
        return this.post(`${this._api}incluir`, dados);
    } 

    postAcordoLote(dados : any){        
        return this.post(`${this._api}incluirLote`, dados);
    } 
       
    getAcordo() {
        return (this.get(`${this._api}acordos`));
    } 
    
    getAcordoPorId(acordoId : any) {
        return (this.get(`${this._api}${acordoId}`));        
    }      

    getRegrasParcelamento(valor : any) {
        return (this.get(`${this._api}ObterConfiguracaoPagamento/${valor}`));
    } 
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/acordo.service.ts